<template>
  <vs-popup title="Ajouter un client" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-type="flex" vs-w="12">
        <input
          type="file"
          label="Importer un fichier d'utilisateurs"
          ref="updateImgInput"
          id="updateImgInput"
          @change="updateCurrImg"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          v-on:change="handleFileUpload()"
          :danger="!!formErrors.file"
          :danger-text="formErrors.file ? formErrors.file[0] : ''"
        />
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-w="12">
        <small class="text-danger">{{
          formErrors.file ? formErrors.file[0] : ""
        }}</small>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          color="primary"
          class="mt-2 mr-2"
          type="filled"
          @click="downloadModelFile()"
          >Fichier modèle</vs-button
        >
        <vs-button
          color="primary"
          class="mt-2 mr-2"
          type="filled"
          @click="importFile()"
          >Importer</vs-button
        >
        <vs-button
          color="primary"
          class="mt-2"
          type="border"
          @click="$emit('closePrompt')"
          >Annuler</vs-button
        >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  name: "add",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    importCallBack: {
      type: Function,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        this.resetErrors();
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  data: () => ({
    form: {
      file: "",
    },
    formErrors: {},
  }),
  methods: {
    handleFileUpload() {
      this.form.file = this.$refs.updateImgInput.files[0];
      this.formErrors = {};
    },
    updateCurrImg() {},
    downloadModelFile() {
      this.$vs.loading();
      this.$http({
        url: "/customers/upload/upload-template",
        method: "POST",
        responseType: "blob",
        data: {
          name: "customers.xlsx",
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "customers.xlsx");
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
    importFile() {
      this.$vs.loading();
      let formData = new FormData();
      formData.append("file", this.form.file);
      this.$http
        .post("customers/upload", formData)
        .then((response) => {
          this.$vs.loading.close();

          if (response.data.history) {

            this.$vs.notify({
              title: "Succès",
              text: "Importation effectuée avec succès",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.resetErrors();

            this.importCallBack(response.data.history);
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          } else {
            this.$vs.notify({
              title: "Erreur",
              text: "Veuillez valider les champs du formulaire",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.formErrors = error.response.data.errors;
          }
        });
    },
    resetErrors(field) {
      if (field) {
        this.formErrors[field] = null;
      } else {
        this.formErrors = [];
        Object.keys(this.form).forEach((index) => (this.form[index] = null));
      }
    },
  },
};
</script>

<style scoped>
#message:hover {
  cursor: pointer;
  text-decoration: underline;
}
#updateImgInput {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  font-size: 1rem;
  width: 500px;
  color: inherit;
  position: relative;
  border-radius: 11px;
  height: fit-content;
}
</style>
